// storeAdapter.js
// Adapter for accessing the reference number store

import useReferenceNumberStore from '../../stores/useReferenceNumberStore';

/**
 * Get reference citation data from the store.
 * The `reportId` parameter is accepted for call-site compatibility but ignored —
 * the store is now flat (one Y.Doc, no per-reportId keying).
 *
 * @param {string} _reportId  (unused — kept for compat)
 * @returns {{ numbersByLocalId: Map, referencesByMark: Map }}
 */
export function getStoreCitationData(_reportId) {
    const store = useReferenceNumberStore.getState();
    return {
        numbersByLocalId: store.numbersByLocalId || new Map(),
        referencesByMark: store.referencesByMark || new Map(),
    };
}

/**
 * Subscribe to citation data changes.
 * Fires callback whenever the flat citationVersion counter increments.
 *
 * @param {string}   _reportId  (unused — kept for compat)
 * @param {Function} callback
 * @returns {Function} Unsubscribe function
 */
export function subscribeToCitationData(_reportId, callback) {
    return useReferenceNumberStore.subscribe(
        (state) => state.citationVersion || 0,
        callback
    );
}

/**
 * Initialize the Y.Map subscription for citation numbering.
 * Call once when the editor mounts, after yReferenceMarks is available.
 *
 * @param {import('yjs').Map} yReferenceMarks
 */
export function initializeStoreSubscription(yReferenceMarks) {
    if (!yReferenceMarks) return;
    const store = useReferenceNumberStore.getState();
    store.subscribeToReferences(yReferenceMarks);
}
